export default {
    household: {},
    retirementNavigator: [],
    companyLogo: '',
    planAge: 0,
    planLength: 0,
    incomeBucketStyles: {},
    incomeBuckets: [],
    brokerageAccountGrowthTypes: [],
    benchmark: [],
    incomeStreams: [],
    incomeStream: {},
    incomeStreamStyles: {},
    cashAccount: [],
    individuals: [],
    beneficiaries: [],
    iavAccountGroupedTypeLabels: [],
    iavAccountOwnerTypes: {},
    iavAccounts: [],
    lifeInsuranceTypes: [],
    otherIncomes: [],
    otherIncomeTypes: [],
    lifeInsurances: [],
    relativeYearMonthlyIncome: [],
    relativeYearMonthlyNeeds: [],
    relativeYearBrokerageAccountStartingBalance: [],
    relativeYearBenchmarkStartingBalance: [],
    relativePlanYearDropdown: [],
    sipsTable: [],
    growthSipsTable: [],
    annualSavings: [],
    personOneAgeThroughYears: [],
    personTwoAgeThroughYears: [],
    yearsPeopleDie: [],
    years: [],
    performanceIndicies: [],
    brokerageAccount: [],
    incomeBucketCoveredPerson: {},
    incomeBucketCoveredPersonLabels: {},
    lifeInsuranceTypeLabels: [],
    savingsAccountValueCalculationMethods: {},
    savingsAccount: [],
    iavAccountTypeLabels: [],
    integrations: {},
    estimatedCurrentIncome: 0,
    relativeYearPortfolioStartingBalance: [],
    iavAccountsStatistics: [],
    incomeBucketsStatistics: [],
    loading: true,
    hidePastPlanYears: true,
    successMeter: [],
    properties: [],
    liabilities: [],
    individualsDropdown: [],
    performance: null,
    performanceOptions: null, //[]
    positions: null,
    financialSummary: null,
    integrationStatus: {
        performance_reporting_active: false,
        data_aggregation_active: false
    }
}
